import styled from 'styled-components';
import {
  FlexCenterAligned,
  FlexColumn,
  FlexibleDiv
} from '../../../../../styled/common';
import { Breakpoints } from '../../../../../styled/constants';

export const ApartmentGalleryContainer = styled(FlexColumn)`
  padding-bottom: 40px;
  gap: 10px;
  flex: 1 1 0%;
  min-width: 0;
`;

export const GalleryImg = styled.div<{ $isZoomed: boolean }>`
  overflow: hidden;
  width: 100%;
  height: 245px;
  position: relative;

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    height: ${({ $isZoomed }) => ($isZoomed ? '100%' : '377px')};
    cursor: zoom-in;

    ${({ $isZoomed }) =>
      $isZoomed &&
      `
      cursor: zoom-out;
      position: absolute;
      right: 0;
      left: 0;
      inset: 0;
      z-index: 1000;
      background: #fff;
    `};
  }
`;

export const SliderTrack = styled.div<{ $index: number }>`
  display: flex;
  height: 100%;
  transform: ${({ $index }) => `translateX(-${$index * 100}%)`};
  transition: transform 0.3s ease;
`;

export const Slide = styled.div`
  flex: 0 0 100%;
  height: 100%;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border: 1px solid ${({ theme }) => theme.colors.border.primary};
    border-radius: 7px;
    display: block;
  }
`;

export const Thumbnails = styled(FlexibleDiv)`
  display: flex;
  gap: 10px;
  overflow-x: auto;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Thumb = styled.div<{ $active: boolean }>`
  flex: 0 0 auto;
  cursor: pointer;
  border-radius: 4px;
  border: 1px solid
    ${({ $active, theme }) =>
      $active ? theme.colors.systemColors.blue : theme.colors.border.primary};

  img {
    width: 112px;
    height: 63px;
    object-fit: contain;
    display: block;
  }
`;

export const Counter = styled(FlexCenterAligned)`
  position: absolute;
  height: 25px;
  bottom: 15px;
  padding: 0 15px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.4);
  color: #fff;
  border-radius: 7px;
  font-size: 12px;
`;
